import './App.css'
import React, { useLayoutEffect } from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './assets/scss/_variable.scss'
import './bootstrap.min.css'
import './common.scss'
import Layout from './components/Layout'
import { PATH } from './constants/router'
import { AppParamsContextProvider, useAppParamsContext } from './context/AppParamsContext'
import { AppUserContextProvider } from './context/AppUserContext'
import { TrafficFineVehicleContextProvider } from './context/TrafficFineVehicleContext'
import { ROUTERS } from './router'

const AppInitializer = () => {
  const { appThemeName } = useAppParamsContext()

  useLayoutEffect(() => {
    if (appThemeName) {
      document.body.setAttribute('data-theme', String(appThemeName).toUpperCase())
    } else {
      document.body.removeAttribute('data-theme')
    }

    const loadingScreen = document.querySelector('.splash-screen-loading')
    if (loadingScreen) {
      loadingScreen.style.display = 'none'
    }
  }, [appThemeName])

  return null
}

function App() {
  return (
    <AppParamsContextProvider>
      <AppInitializer />
      <AppUserContextProvider>
        <TrafficFineVehicleContextProvider>
          <Router>
            <Switch>
            {Object.keys(ROUTERS).map((key) => {
              return (
                <Route
                  key={ROUTERS[key].path || key}
                  exact
                  path={ROUTERS[key].path}
                  component={(props) => (
                    <React.Suspense fallback={null}>
                      <Layout {...props} Component={ROUTERS[key].component} hideMobileMenu={ROUTERS[key].hideMobileMenu} />
                    </React.Suspense>
                  )}
                />
              )
            })}
            <Redirect to={PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_LOOKUP} />
            </Switch>
          </Router>
        </TrafficFineVehicleContextProvider>
      </AppUserContextProvider>
    </AppParamsContextProvider>
  )
}

export default App
